class LspFormFieldService {
  validateField(form, field) {
    form[field].$validate();
    form[field].$submitted = true;
    if (!form[field].$viewValue) {
      form[field].$submitted = false;
    }
  }

  shouldShowValidation(field) {
    return ((field.$$parentForm.$submitted || field.$submitted) && field.$pristine) || field.$touched;
  }
}

export default LspFormFieldService;



// WEBPACK FOOTER //
// ./src/modules/utils/lsp-validators/lsp-form-field-validator/lsp-form-field-service.js